import { getPrefixSearchAutocompleteApi } from "api/search/getPrefixSearchAutocompleteApi";

export default function autocomplete(searchPhrase: string, callBack?: any, context?: string, extraParams?: any) {
  const updatedNewValue = searchPhrase.replace(/&nbsp;/g, "").trim();

  if (updatedNewValue) {
    if (callBack) {
      callBack(true);
    }

    return getPrefixSearchAutocompleteApi(updatedNewValue, false, context, extraParams).then((res) => {
      let { data } = res;
      let vehicle = null;

      if (data && typeof data === "object" && !Array.isArray(data)) {
        const items = data.regular || [];
        vehicle = data.vehicle || null;
        data = items;
      }

      if (!data || data.length === 0) {
        return getPrefixSearchAutocompleteApi(updatedNewValue, true, context, extraParams).then((_res) => _res);
      }

      return { ...res, data, vehicle };
    });
  }

  return new Promise((resolve) => {
    resolve({ data: [] });
  });
}
